import CanvasInput from './CanvasInput'

export default CanvasInput
